<template>
  <div ref="holder" class="tempt">
    <screen-img
      v-if="shouldLoad && src"
      :src="src"
      :classOption="classOption"
    />
  </div>
</template>

<script>
export default {
  name: "lazy-device-screen",
  props: {
    src: String,
    classOption: {
      type: String,
      default: "screen-img",
    },
  },
  data() {
    return {
      shouldLoad: false,
    };
  },
  mounted() {
    if (!this.src || typeof IntersectionObserver === "undefined") {
      this.shouldLoad = true;
      return;
    }
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.shouldLoad = true;
          this.observer.disconnect();
          this.observer = null;
        }
      },
      { rootMargin: "120px 0px", threshold: 0.01 }
    );
    this.observer.observe(this.$refs.holder);
  },
  beforeDestroy() {
    this.observer?.disconnect();
    this.observer = null;
  },
};
</script>

<style lang="less" scoped>
.tempt {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: inherit;
}
</style>
